// The ARQNXS arc mark (arc + X terminal) extracted from src/assets/arqnxs.svg.
// Two sanctioned uses only: favicon/OG mark, or oversized tonal crop
// (text-navy-deep inside a bg-navy tile). Renders in currentColor.
import React from 'react';

const ArcMark = ({ className = '' }) => (
  <svg
    viewBox="103 226 353 148"
    aria-hidden="true"
    focusable="false"
    className={className}
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="m440.55,343.2c-.41-1.09-.62-2.13-.62-3.12s.22-2.02.66-3.12c.44-1.09,1.12-2.41,2.05-3.94l12.63-20.09h-14.02l-11.03,17.97c-11.48-17.36-26-34.27-41.69-48.37-40.96-37.45-97.03-57.24-152.56-56.5-20.04.04-39.53,1.87-58.91,8.84-33.11,11.27-59.51,38.84-69,72.9-2.87,10.1-4.78,20.6-4.82,31.16-.02,5.12.86,10.24,2.86,14.96,14.21,33.57,68.22,22.69,64.22-15.71-.12-1.12-.3-2.11-.45-3.17-2.22-15.23,1.6-32.35,12.24-43.78,14.07-15.25,37.76-25.01,58.24-28.22,31.87-5.11,64.67-3.03,95.42,7.57,33.01,11.25,59.47,33.33,79.84,60.18,4.03,5.31,4.75,12.4.82,17.79l-14.3,19.58h14.35l9.92-16.15c1.15-1.91,2-3.83,2.54-5.74.02-.05.03-.11.04-.16.02.05-.02.11,0,.16.57,1.91,1.41,3.83,2.5,5.74l10,16.15h14.27l-13.12-20.91c-.98-1.59-1.68-2.92-2.09-4.02Z" />
  </svg>
);

export default ArcMark;
